export default function useErrorHandling() {
  const { $config, $sentry } = useNuxtApp()

  const logError = (info: string, error: unknown, vm?: Record<string, unknown> | null) => {
    if ($config.public.mode === 'staging' || $config.public.mode === 'production') {
      $sentry?.captureException(error, {
        extra: {
          info,
          vm,
        },
      })
    } else {
      console.error(info, error)
    }
  }

  const handleNotFound = async (error: unknown, context = 'Resource') => {
    if (!isFetchErrorWithStatus(error, 404)) throw error
    logError(`${context} not found (404) — redirecting to /404`, error)
    await navigateTo({ name: '404' })
  }

  if (getCurrentInstance()) {
    onErrorCaptured((error, vm, info) => {
      logError(info, error, vm as Record<string, unknown> | null)
    })
  }

  return {
    logError,
    handleNotFound,
  }
}
